var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconDoorList = function SvgIconDoorList(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-doorList",
    transform: "translate(4710 -7053)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4350",
    "data-name": "Rectangle 4350",
    width: 40,
    height: 40,
    rx: 4,
    transform: "translate(-4710 7093) rotate(-90)",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1271",
    "data-name": "Path 1271",
    d: "M-5252-1763a3,3,0,0,1-3-3v-16a3,3,0,0,1,3-3h1v-1a1,1,0,0,1,1-1,1,1,0,0,1,1,1v1h8v-1a1,1,0,0,1,1-1,1,1,0,0,1,1,1v1h1a3,3,0,0,1,3,3v16a3,3,0,0,1-3,3Zm-1-19v16a1,1,0,0,0,1,1h14a1,1,0,0,0,1-1v-16a1,1,0,0,0-1-1h-1v1a1,1,0,0,1-1,1,1,1,0,0,1-1-1v-1h-8v1a1,1,0,0,1-1,1,1,1,0,0,1-1-1v-1h-1A1,1,0,0,0-5253-1782Zm6,15a1,1,0,0,1-1-1,1,1,0,0,1,1-1h4a1,1,0,0,1,1,1,1,1,0,0,1-1,1Zm-4-1a1,1,0,0,1,1-1,1,1,0,0,1,1,1,1,1,0,0,1-1,1A1,1,0,0,1-5251-1768Zm4-4a1,1,0,0,1-1-1,1,1,0,0,1,1-1h6a1,1,0,0,1,1,1,1,1,0,0,1-1,1Zm-4-1a1,1,0,0,1,1-1,1,1,0,0,1,1,1,1,1,0,0,1-1,1A1,1,0,0,1-5251-1773Zm4-4a1,1,0,0,1-1-1,1,1,0,0,1,1-1h7a1,1,0,0,1,1,1,1,1,0,0,1-1,1Zm-4-1a1,1,0,0,1,1-1,1,1,0,0,1,1,1,1,1,0,0,1-1,1A1,1,0,0,1-5251-1778Z",
    transform: "translate(555 8848)"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconDoorList, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-doorList.7c115a6d.svg";
export { ForwardRef as ReactComponent };